import { instance } from "libs/api";

import { ApiRoutesDeliveryCompanies } from "../../constants";
import { DeliveryCompany } from "../../deliveryCompanies.types";
import { CreateDeliveryCompanyRequestBody } from "./createDeliveryCompany.types";

export const requestCreateDeliveryCompany = async (
  body: CreateDeliveryCompanyRequestBody
): Promise<DeliveryCompany> => {
  return await instance.post(ApiRoutesDeliveryCompanies.Companies, body);
};
